export default class OrderApi {
  static processOrder(order) {
    return fetch("/api/order", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(order)
    })
      .then(res => res.json())
      .then(
        (result) => {
          return result
        },
        (error) => {
          return error          
        }
      )
  }
  

  static redeemAndUpgrade(order) {
    return fetch("/api/order/redeemUpgrade", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(order)
    }).then(res => res.json().then(result => ({
      data: result,
      status: res.status
    })
    ))
  }

  static findSecretConstants() {
    return fetch(`/api/secretConstants`, {
      method: 'POST',
      headers:new Headers( {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    })
      .then(res => res.json())
      .then(
        (result) => {
          return result
        },
        (error) => {
          return error
        }
      )
  }

  static creditCardUpdate(order) {
    return fetch("/api/order/creditcardupdate", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      //body: JSON.stringify(order)
    }).then(res => res.json().then(result => ({
      data: result,
      status: res.status
    })
    ))
  }
}